import type { FaireProductEntity } from "../../entity_types/product";

export const p_8gx8acag4q: FaireProductEntity = {
  token: "p_8gx8acag4q",
  type: "product",
  name: "Rusty Tin Collection Farmhouse Sign",
  brandName: "Stir Crazy Signs",
  imageUrl:
    "https://cdn.faire.com/fastly/755a1918976ac4f5a82a7533db4545bf5f4189e86270f9ba6f709db69f9bfc2f.png",
  priceDollars: 20.4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/d4512025d72b8ef96a0ca1177da0915b48240794e8b4129303e28db13c8832a7.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
